<div class="shell">
  <aside>
    <div class="marca">CRM<span>Stack</span></div>
    <small>BACKOFFICE</small>
    <nav>
      <button (click)="abrir('dashboard')">▦ Visão geral</button
      ><b>FINANCEIRO</b><button (click)="abrir('Planos')">Planos</button
      ><button (click)="abrir('Assinaturas')">Assinaturas</button
      ><button (click)="abrir('Pagamentos')">Pagamentos</button><b>SUPORTE</b
      ><button (click)="abrir('Wiki')">Wiki</button
      ><button (click)="abrir('Responsaveis')">Usuários das empresas</button
      ><button (click)="abrir('gestao')">Usuários da gestão</button>
    </nav>
    <div class="perfil">
      <strong>{{ auth.token?.nome }}</strong
      ><span>{{ auth.token?.email }}</span
      ><button (click)="auth.sair()">Sair</button>
    </div>
  </aside>
  <main>
    <header>
      <div>
        <h1>{{ aba === "dashboard" ? "Visão geral" : aba }}</h1>
        <p>Administração interna do CRMStack</p>
      </div>
      <button
        *ngIf="aba === 'Planos' || aba === 'Pagamentos' || aba === 'Wiki'"
        class="primario"
        (click)="novo()"
      >
        + Novo
      </button>
      <button
        *ngIf="aba === 'gestao'"
        class="primario"
        (click)="novoUsuarioGestao()"
      >
        + Novo usuário
      </button>
    </header>
    <section *ngIf="aba === 'dashboard'">
      <div class="metricas">
        <div>
          <span>Empresas</span><strong>{{ dados.empresas }}</strong>
        </div>
        <div>
          <span>Usuários</span><strong>{{ dados.usuariosTenant }}</strong>
        </div>
        <div>
          <span>Contatos</span><strong>{{ dados.contatos }}</strong>
        </div>
      </div>
    </section>
    <section *ngIf="aba !== 'dashboard' && aba !== 'gestao'" class="painel">
      <div
        *ngIf="aba === 'Assinaturas' && extra?.semPlano?.length"
        class="alerta"
      >
        <b>{{ extra.semPlano.length }} empresas sem plano</b
        ><span *ngFor="let e of extra.semPlano"
          >{{ e.nome }} — {{ e.email }}</span
        >
      </div>
      <div class="tabela">
        <table class="tabela-registros">
          <colgroup>
            <col class="col-registro" />
            <col class="col-detalhes" />
            <col class="col-status" />
            <col class="col-acoes" />
          </colgroup>
          <thead>
            <tr>
              <th>Registro</th>
              <th>Detalhes</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let x of itens">
              <td>
                <strong>{{ x.nome || x.titulo || x.empresa || x.email }}</strong
                ><small>{{ x.categoria || x.descricao || x.plano }}</small>
              </td>
              <td>
                {{
                  x.preco || x.valor || (x.dataVigencia | date: "dd/MM/yyyy")
                }}
              </td>
              <td>
                <span class="badge">{{
                  x.status || (x.ativo ? "Ativo" : "Inativo")
                }}</span
                ><em *ngIf="x.diasRestantes != null">
                  {{ x.diasRestantes }} dias</em
                >
              </td>
              <td>
                <button
                  class="link"
                  *ngIf="
                    aba === 'Planos' || aba === 'Pagamentos' || aba === 'Wiki'
                  "
                  (click)="editar(x)"
                >
                  Editar</button
                ><button
                  class="link"
                  *ngIf="aba === 'Pagamentos'"
                  (click)="
                    acao(
                      'Pagamentos/' + x.id + '/EnviarBoleto',
                      'Boleto enviado.'
                    )
                  "
                >
                  Enviar boleto</button
                ><button
                  class="link"
                  *ngIf="aba === 'Assinaturas'"
                  (click)="
                    acao('Assinaturas/' + x.id + '/Comunicar', 'Aviso enviado.')
                  "
                >
                  Avisar</button
                ><button
                  class="link"
                  *ngIf="aba === 'Responsaveis'"
                  (click)="
                    acao(
                      'Responsaveis/' + x.id + '/ResetarSenha',
                      'Nova senha enviada.'
                    )
                  "
                >
                  Gerar senha</button
                ><button
                  class="link"
                  *ngIf="aba === 'Pagamentos' || aba === 'Wiki'"
                  (click)="remover(x)"
                >
                  Excluir
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <section *ngIf="aba === 'gestao'" class="painel">
      <div class="tabela">
        <table class="tabela-usuarios">
          <thead>
            <tr>
              <th>Nome</th>
              <th>E-mail corporativo</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let u of usuarios">
              <td>{{ u.nome }}</td>
              <td>{{ u.email }}</td>
              <td>
                <span class="badge" [class.inativo]="!u.ativo">{{
                  u.ativo ? "Ativo" : "Inativo"
                }}</span>
              </td>
              <td>
                <button class="link" (click)="resetarSenha(u)">
                  Enviar nova senha
                </button>
                <button class="link" (click)="status(u)">
                  {{ u.ativo ? "Desativar" : "Ativar" }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </main>
</div>
<div class="modal" *ngIf="modal" (click)="modal = false">
  <div class="modal-dialogo" (click)="$event.stopPropagation()">
    <header class="modal-cabecalho">
      <div>
        <small>CRMSTACK BACKOFFICE</small>
        <h2>
          {{
            aba === "gestao"
              ? "Novo usuário da gestão"
              : (edicao.id ? "Editar " : "Novo ") + aba
          }}
        </h2>
      </div>
      <button
        type="button"
        class="fechar"
        (click)="modal = false"
        aria-label="Fechar"
      >
        ×
      </button>
    </header>
    <div class="modal-corpo">
      <div class="form-grid" *ngIf="aba === 'gestao'">
        <div class="form-group campo-largo">
          <label>Nome</label
          ><input
            class="form-control"
            [(ngModel)]="edicao.nome"
            placeholder="Nome completo"
          />
        </div>
        <div class="form-group campo-largo">
          <label>E-mail corporativo</label
          ><input
            class="form-control"
            type="email"
            [(ngModel)]="edicao.email"
            placeholder="usuario@agenciapublik.com.br"
          />
        </div>
        <div class="form-group campo-largo">
          <label>Senha inicial</label
          ><input
            class="form-control"
            type="password"
            [(ngModel)]="edicao.senha"
            placeholder="Mínimo de 10 caracteres"
          />
        </div>
      </div>
      <div class="form-grid" *ngIf="aba === 'Planos'">
        <div class="form-group campo-largo">
          <label>Nome</label
          ><input class="form-control" [(ngModel)]="edicao.nome" />
        </div>
        <div class="form-group campo-largo">
          <label>Descrição</label
          ><textarea
            class="form-control"
            rows="4"
            [(ngModel)]="edicao.descricao"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Preço</label
          ><input class="form-control" [(ngModel)]="edicao.preco" />
        </div>
        <div class="form-group">
          <label>Usuários</label
          ><input
            class="form-control"
            type="number"
            [(ngModel)]="edicao.usuarios"
          />
        </div>
        <div class="form-group">
          <label>Espaço (GB)</label
          ><input
            class="form-control"
            type="number"
            [(ngModel)]="edicao.espaco"
          />
        </div>
      </div>
      <div class="form-grid" *ngIf="aba === 'Pagamentos'">
        <div class="form-group">
          <label>ID da empresa</label
          ><input
            class="form-control"
            type="number"
            [(ngModel)]="edicao.empresaId"
          />
        </div>
        <div class="form-group">
          <label>Valor</label
          ><input
            class="form-control"
            type="number"
            [(ngModel)]="edicao.valor"
          />
        </div>
        <div class="form-group campo-largo">
          <label>Descrição</label
          ><input class="form-control" [(ngModel)]="edicao.descricao" />
        </div>
        <div class="form-group">
          <label>Vencimento</label
          ><input
            class="form-control"
            type="date"
            [(ngModel)]="edicao.dataVencimento"
          />
        </div>
        <div class="form-group">
          <label>URL do boleto</label
          ><input class="form-control" [(ngModel)]="edicao.boletoUrl" />
        </div>
      </div>
      <div class="form-grid" *ngIf="aba === 'Wiki'">
        <div class="form-group">
          <label>Título</label
          ><input class="form-control" [(ngModel)]="edicao.titulo" />
        </div>
        <div class="form-group">
          <label>Categoria</label
          ><input class="form-control" [(ngModel)]="edicao.categoria" />
        </div>
        <div class="form-group campo-largo">
          <label>Conteúdo</label>
          <div class="editor-wiki">
            <div class="editor-modos">
              <button
                type="button"
                [class.ativo]="modoEditor === 'visual'"
                (click)="alterarModoEditor('visual')"
              >
                Visual</button
              ><button
                type="button"
                [class.ativo]="modoEditor === 'html'"
                (click)="alterarModoEditor('html')"
              >
                HTML</button
              ><button
                type="button"
                [class.ativo]="modoEditor === 'markdown'"
                (click)="alterarModoEditor('markdown')"
              >
                Markdown
              </button>
            </div>
            <div class="editor-toolbar" *ngIf="modoEditor === 'visual'">
              <button
                type="button"
                title="Negrito"
                (click)="formatarEditor('bold')"
              >
                <b>B</b></button
              ><button
                type="button"
                title="Itálico"
                (click)="formatarEditor('italic')"
              >
                <i>I</i></button
              ><button
                type="button"
                title="Sublinhado"
                (click)="formatarEditor('underline')"
              >
                <u>U</u></button
              ><button
                type="button"
                title="Título"
                (click)="formatarEditor('formatBlock', 'h2')"
              >
                H2</button
              ><button
                type="button"
                title="Lista"
                (click)="formatarEditor('insertUnorderedList')"
              >
                • Lista</button
              ><button
                type="button"
                title="Lista numerada"
                (click)="formatarEditor('insertOrderedList')"
              >
                1. Lista</button
              ><button
                type="button"
                title="Link"
                (click)="formatarEditor('createLink', 'https://')"
              >
                Link</button
              ><button
                type="button"
                title="Inserir imagem por URL"
                (click)="inserirImagemUrl()"
              >
                Imagem URL</button
              ><button
                type="button"
                title="Enviar imagem"
                (click)="selecionarImagem()"
              >
                Enviar imagem</button
              ><input
                #arquivoImagem
                class="arquivo-imagem"
                type="file"
                accept="image/*"
                (change)="inserirImagemArquivo($event)"
              /><button
                type="button"
                title="Remover formatação"
                (click)="formatarEditor('removeFormat')"
              >
                Limpar
              </button>
            </div>
            <div
              #editorVisual
              *ngIf="modoEditor === 'visual'"
              class="editor-visual"
              contenteditable="true"
              [innerHTML]="edicao.conteudo || ''"
              (keyup)="salvarSelecaoEditor()"
              (mouseup)="salvarSelecaoEditor()"
              (input)="atualizarConteudoVisual($event)"
            ></div>
            <textarea
              *ngIf="modoEditor === 'html'"
              class="editor-codigo"
              [(ngModel)]="edicao.conteudo"
              spellcheck="false"
              placeholder="Digite o HTML..."
            ></textarea>
            <textarea
              *ngIf="modoEditor === 'markdown'"
              class="editor-codigo"
              [(ngModel)]="conteudoMarkdown"
              spellcheck="false"
              placeholder="# Título&#10;&#10;Escreva em **Markdown**..."
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <footer class="modal-rodape">
      <button class="btn-cancelar" type="button" (click)="modal = false">
        Cancelar</button
      ><button
        class="primario"
        type="button"
        [disabled]="salvando"
        (click)="aba === 'gestao' ? salvarUsuarioGestao() : salvarItem()"
      >
        {{ salvando ? "Salvando..." : "Salvar" }}
      </button>
    </footer>
  </div>
</div>
